import { render, staticRenderFns } from "./BuscadorInput.vue?vue&type=template&id=224f4a8f&"
import script from "./BuscadorInput.vue?vue&type=script&lang=js&"
export * from "./BuscadorInput.vue?vue&type=script&lang=js&"
import style0 from "./BuscadorInput.vue?vue&type=style&index=0&id=224f4a8f&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports